import { defineMessages } from '@formatjs/intl';

import { Review } from '@/components/homepageRefresh/homepage/Testimonials/types';

export const messages = defineMessages({
	reviewsHeading: {
		id: 'subpage.mindfulness.testimonials.reviewsHeading2',
		defaultMessage: 'Over 2 million 5-star reviews.',
		description: 'Heading for section showing users that love Calm',
	},
	review1Quote: {
		id: 'subpage.mindfulness.testimonials.review1quote',
		defaultMessage:
			'Calm has changed my life in immeasurable ways. I am more resilient and feel so much more connected to myself.',
		description: 'Quote from a Calm app review',
	},
	review1Author: {
		id: 'subpage.mindfulness.testimonials.review1Author',
		defaultMessage: 'Allison from San Jose',
		description: 'Author of Calm app review',
	},
	review2Quote: {
		id: 'subpage.mindfulness.testimonials.review2quote',
		defaultMessage:
			'I have a very busy brain and can find it hard to unwind. Now a daily practice is actually so wonderful and healing for me.',
		description: 'Quote from a Calm app review',
	},
	review2Author: {
		id: 'subpage.mindfulness.testimonials.review2Author',
		defaultMessage: 'John from Chicago',
		description: 'Author of Calm app review',
	},
	review3Quote: {
		id: 'subpage.mindfulness.testimonials.review3quote',
		defaultMessage:
			'I have tried other meditation and gratitude apps, but this one has everything and the best teachers.',
		description: 'Quote from a Calm app review',
	},
	review3Author: {
		id: 'subpage.mindfulness.testimonials.review3Author',
		defaultMessage: 'Jen from Scarsdale',
		description: 'Author of Calm app review',
	},
	review4Quote: {
		id: 'subpage.mindfulness.testimonials.review4quote',
		defaultMessage:
			"Medication isn't for me, so I decided to give Calm a try. I am so glad that I did. Now I begin and end every day with guided meditations.",
		description: 'Quote from a Calm app review',
	},
	review4Author: {
		id: 'subpage.mindfulness.testimonials.review4Author',
		defaultMessage: 'Kimmy from St. Paul',
		description: 'Author of Calm app review',
	},
	review5Quote: {
		id: 'subpage.mindfulness.testimonials.review5quote',
		defaultMessage:
			"I'm not sure how Tamara knows just what I need to hear in the daily meditations, but it almost always hits me in just the right way.",
		description: 'Quote from a Calm app review',
	},
	review5Author: {
		id: 'subpage.mindfulness.testimonials.review5Author',
		defaultMessage: 'Mikey from Costa Mesa',
		description: 'Author of Calm app review',
	},
	review6Quote: {
		id: 'subpage.mindfulness.testimonials.review6quote',
		defaultMessage:
			"I've been meditating for 3 years and it's been able to really reduce my anxiety. Calm is a life-changing app.",
		description: 'Quote from a Calm app review',
	},
	review6Author: {
		id: 'subpage.mindfulness.testimonials.review6Author',
		defaultMessage: 'Celeste from New York City',
		description: 'Author of Calm app review',
	},
});

export const reviews: Review[] = [
	{
		quote: messages.review1Quote,
		author: messages.review1Author,
	},
	{
		quote: messages.review2Quote,
		author: messages.review2Author,
	},
	{
		quote: messages.review3Quote,
		author: messages.review3Author,
	},
	{
		quote: messages.review4Quote,
		author: messages.review4Author,
	},
	{
		quote: messages.review5Quote,
		author: messages.review5Author,
	},
	{
		quote: messages.review6Quote,
		author: messages.review6Author,
	},
];
